var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customer)?_c('div',[_c('h3',[_vm._v("\n    "+_vm._s(_vm.customer.name)),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-danger ml-3"},[_vm._v("GELÖSCHT")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.isDeleted)?_c('resource',{attrs:{"title":"Ändern","resource":"customerProfile","resourceName":"Mitglied","original":_vm.customer,"attributes":[
          {
            name: 'name',
            label: 'Name'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Profil bearbeiten")])])]):_vm._e()],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"card card--primary-color card--form mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('support-avatar-upload',{staticClass:"mb-3",attrs:{"customer-profile":_vm.id}}),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('customer-media',{attrs:{"media":_vm.customer.media,"update-url":_vm.customer.media_update_url,"isAvatar":true}})],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/message","filter":[
          {
            name: 'with',
            value: ['sender', 'receiver']
          },
          {
            name: 'where',
            attributes: {
              sender_id: _vm.id
            }
          }
        ],"attributes":[
          {
            attribute: 'id',
            name: 'ID'
          },
          {
            attribute: 'receiver',
            type: 'LinkFriendCell',
            name: 'Chatpartner',
            sortable: false
          },
          {
            name: 'Inhalt',
            type: 'MessageContentCell'
          },
          {
            attribute: 'created_at',
            name: 'Gesendet am',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Nachrichten")])])],1)]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/userSession","filter":[
          {
            name: 'where',
            attributes: {
              user_id: _vm.customer.user.id
            }
          }
        ],"attributes":[
          {
            attribute: 'ip',
            name: 'IP-Adresse'
          },
          {
            attribute: 'country_code',
            name: 'Land',
            type: 'FlagCell',
            sortable: false
          },
          {
            attribute: 'session_id',
            name: 'Session-ID'
          },
          {
            attribute: 'user_agent',
            name: 'Browser- und Gerätedaten'
          },
          {
            attribute: 'created_at',
            name: 'Erstellt am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'closed_at',
            name: 'Geschlossen am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'duration',
            name: 'Zeitspanne',
            sortable: false
          },
          {
            attribute: 'success',
            name: 'Erfolgreich eingeloggt',
            type: 'CheckMarkerCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Anmeldungen")])])],1)]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Media")])])}]

export { render, staticRenderFns }